import { ROUTE_MAPPINGS, ROUTE_MAPPINGS_ADMIN } from "../constants/routeMappings";
import { setApprovalDetails, setAuthDetails, setDeliveryPersonId, setLoginDetails, setPermissions } from "../Redux/Slices/counterSlice";

export function handleLoginResponse({
  responseData,
  token, 
  dispatch,
  navigate,
  showSnackbar,
  redirectTo,
}) {
  const userType = responseData?.usertype;
  const permissions = responseData?.roles;
  const permissionsArray = permissions?.[0]?.permissions || [];

  const loginPayload = {
    jwt: token || responseData.token, 
    userType,
    userId: responseData?.sub,
    name: responseData?.name,
    email: responseData?.email,
    phone_number: responseData?.phone_number,
    stripeAccountId: responseData?.stripeAccountId || "",
  };
  

  if (!responseData?.name || !responseData?.phone_number) {
 
    loginPayload.otpVerified = true;
    dispatch(setAuthDetails(loginPayload));
    navigate(`/auth/register`);
    return
  }

  // Normal user flow
  if (userType === "normal user") {
    updateReduxLoginData(dispatch, loginPayload, permissions);
    navigate(redirectTo || "/customer-home");
    return;
  }

  // Admin user flow
  if (userType === "admin") {
    if (!permissionsArray.length) {
      navigate("/auth/unauthorized");
      return;
    }
    const analyticsPermission = permissionsArray.find((p) =>
      p.resource.includes("Dashboard")
    );
    updateReduxLoginData(dispatch, loginPayload, permissions);
    if (analyticsPermission) {
      navigate(ROUTE_MAPPINGS_ADMIN["Dashboard"]);
    } else {
      const firstResource = permissionsArray[0]?.resource;
      navigate(ROUTE_MAPPINGS_ADMIN[firstResource] || "/app/analytics-dashboard");
    }
    return;
  }

  // Business/Employee user flow
  if (
    userType === "business user" ||
    userType === "employee user"
  ) {
    if (responseData?.isApproved === "approved") {
      if (!permissionsArray.length) {
        navigate("/auth/unauthorized");
        return;
      }
      const analyticsPermission = permissionsArray.find((p) =>
        p.resource.includes("Analytics_and_report")
      );
      loginPayload.storeId = responseData?.stores?.[0] || null;
      updateReduxLoginData(dispatch, loginPayload, permissions);
      if (analyticsPermission) {
        navigate(ROUTE_MAPPINGS["Analytics_and_report"]);
      } else {
        const firstResource = permissionsArray?.[0]?.resource?.split(":")[1];
        navigate(ROUTE_MAPPINGS[firstResource] || "/app/dashboard");
      }
    } else {
      dispatch(setLoginDetails(loginPayload));
      dispatch(
        setApprovalDetails({
          jwt: token || responseData.token,
          name: responseData?.name,
          email: responseData?.email,
          phone_number: responseData?.phone_number,
          userType,
        })
      );
      navigate("/auth/approval");
    }
    return;
  }

  // Delivery user flow
  if (userType === "delivery user") {
    if (responseData?.isApproved === "approved") {
      updateReduxLoginData(dispatch, loginPayload, []);
      dispatch(setDeliveryPersonId(responseData?.deliveryPersonId));
      navigate("/delivery/earnings-dashboard");
    } else {
      dispatch(setLoginDetails(loginPayload));
      dispatch(
        setApprovalDetails({
          jwt: token || responseData.token,
          name: responseData?.name,
          email: responseData?.email,
          phone_number: responseData?.phone_number,
          stripeAccountId: responseData?.stripeAccountId || "",
          userType,
        })
      );
      navigate("/auth/approval");
    }
    return;
  }

}

// Utility previously in your page
export function updateReduxLoginData(dispatch, loginPayload, permissions) {
  dispatch(setLoginDetails(loginPayload));
  if (
    loginPayload?.userType === "business user" ||
    loginPayload?.userType === "employee user"
  ) {
    let cleanedPermissions = permissions.map((role) => ({
      ...role,
      permissions: role.permissions.map((p) => ({
        ...p,
        resource: p.resource?.split(":")[1]?.replace(/\_/g, " ") || p.resource,
      })),
    }));
    dispatch(setPermissions(cleanedPermissions));
  } else {
    dispatch(setPermissions(permissions));
  }
}
